import React from 'react';
import {
  Collapse,
  Paper,
  Stack,
  Text,
  TextInput,
  Group,
  Button,
  Select,
} from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';

interface Props {
  showFilters: boolean;
  onToggleFilters: (open: boolean) => void;
  filters: {
    packageId?: string;
    batchNumber: string;
    studentName: string;
    trainerEmail: string;
    courseName: string;
    packageGeneralStatus: string;
    search: string;
    
  };
  onFilterChange: (key: string, value: any) => void;
  onApply: () => void;
  onClear: () => void;
}

export default function PackageFilters({
  showFilters,
  onToggleFilters,
  filters,
  onFilterChange,
  onApply,
  onClear,
}: Props) {
  return (
    <Collapse in={showFilters}>
      <Paper shadow="sm" p="md" withBorder>
        <Stack gap="md">
          {/* <Text fw={600} size="lg">Filter Packages</Text> */}

          <TextInput
            placeholder="Search by student name, email, course, batch number, or package ID"
            leftSection={<IconSearch size={18} />}
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
          />

          {/* Horizontal row container: keeps inputs on one line and allows horizontal scrolling on small screens */}
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', overflowX: 'auto', paddingTop: 6, paddingBottom: 6 }}>
            <div style={{ flex: '0 0 200px', minWidth: 110 }}>
              <TextInput
                size="sm"
                label="Package ID"
                placeholder="Package ID"
                value={filters.packageId || ''}
                onChange={(e) => onFilterChange('packageId', e.target.value)}
              />
            </div>

            <div style={{ flex: '0 0 200px', minWidth: 120 }}>
              <TextInput
                size="sm"
                label="Course Name"
                placeholder="Course"
                value={filters.courseName}
                onChange={(e) => onFilterChange('courseName', e.target.value)}
              />
            </div>

            <div style={{ flex: '0 0 200px', minWidth: 110 }}>
              <TextInput
                size="sm"
                label="Batch No"
                placeholder="Batch"
                value={filters.batchNumber}
                onChange={(e) => onFilterChange('batchNumber', e.target.value)}
              />
            </div>

            <div style={{ flex: '0 0 200px', minWidth: 120 }}>
              <TextInput
                size="sm"
                label="Student"
                placeholder="Student"
                value={filters.studentName}
                onChange={(e) => onFilterChange('studentName', e.target.value)}
              />
            </div>

            <div style={{ flex: '0 0 200px', minWidth: 120 }}>
              <TextInput
                size="sm"
                label="Trainer"
                placeholder="Trainer Email"
                value={filters.trainerEmail}
                onChange={(e) => onFilterChange('trainerEmail', e.target.value)}
              />
            </div>
            <div style={{ flex: '0 0 200px', minWidth: 140 }}>
  <Select
    size="sm"
    label="Package Status"
    placeholder="Status"
    clearable
    data={[
      { value: 'Not Started', label: 'Not Started' },
      { value: 'In-Progress', label: 'In-Progress' },
      { value: 'On-Hold', label: 'On-Hold' },
      { value: 'Payment Issue', label: 'Payment Issue' },
      { value: 'Discard', label: 'Discard' },
      { value: 'Completed', label: 'Completed' },
    ]}
    value={filters.packageGeneralStatus}
    onChange={(val) => onFilterChange('packageGeneralStatus', val || '')}
  />
</div>
          </div>

          <Group justify="flex-end">
            <Button
              variant="default"
              leftSection={<IconX size={18} />}
              onClick={onClear}
            >
              Clear Filters
            </Button>
            <Button
              leftSection={<IconSearch size={18} />}
              onClick={onApply}
            >
              Apply Filters
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Collapse>
  );
}
